import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { PapiPointsTransactionV3 } from '@wix/da-papi-types';

export const initializeTransactionsV3 = createAction(
  'POINTS.INIT_TRANSACTIONS_V3',
  (streamData: {
    hasMore?: boolean;
    nextOffset?: number | null;
    results?: PapiPointsTransactionV3[];
  }) => streamData
);
export const fetchNextTransactionsV3 = createCallbackActionCreator(
  'POINTS.FETCH_NEXT_TRANSACTIONS_V3'
);
